import Scrollbars from 'react-custom-scrollbars'

export default Scrollbars